import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from '@phosphor-icons/react';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { ProductVisual } from '../products/ProductVisual';
import { products } from '../../data/products';
interface CloseScreenProps {
  onRestart: () => void;
}
export function CloseScreen({
  onRestart
}: CloseScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-281" data-mp="1skb2uklkvhlc">
      <Reveal data-id="element-282" data-mp="1siqcz8a7kmtt">
        <h2 className="font-heading text-[36px] leading-[1] tracking-[-0.02em] text-white" data-id="element-283" data-mp="1nm9jrzo5ji9v">
          That’s why they’re a family.
        </h2>
      </Reveal>

      <Reveal delay={0.16} className="mt-6" data-id="element-284" data-mp="22a2zdkd8mksg">
        <div className="space-y-1.5" data-id="element-285" data-mp="1xb9ntxhih3ux">
          {['Different personalities.', 'Different strengths.', 'One that turned up late.', 'Same Filtek heritage.'].map((line, i) => <motion.p key={line} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.24 + i * 0.14,
          duration: 0.5
        }} className="font-body text-[17px] leading-snug text-white/70" data-id="element-286" data-mp="26earzsmtgkvy" data-mpi={i}>
                {line}
              </motion.p>)}
        </div>
      </Reveal>

      <Reveal delay={0.7} className="mt-7" data-id="element-287" data-mp="1q16dbco0m401">
        <div className="rounded-[26px] bg-primary px-5 py-5" data-id="element-288" data-mp="1u5mdqyev0j7v">
          <p className="font-heading text-[26px] leading-[1.05] tracking-[-0.02em] text-background" data-id="element-289" data-mp="1u305ewk59zol">
            Change the solution.
            <br data-id="element-290" data-mp="23ue3r10d0tg5" />
            Not the system.
          </p>
          <div className="mt-4 flex items-end justify-between gap-1 border-t border-[rgba(1,51,43,0.18)] pt-3" data-id="element-291" data-mp="23x0aiyfff4xb">
            {products.map(p => <ProductVisual key={p.id} product={p.id} className="h-[76px] w-auto" data-id="element-292" data-mp="2dtv5568kwl6b" />)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.9} className="mt-7" data-id="element-293" data-mp="2hscbvoo37tn7">
        <PillButton tone="dark" full onClick={onRestart} data-id="element-294" data-mp="iovv3s6nscpg">
          Meet the whole family <ArrowRight size={17} weight="bold" aria-hidden="true" data-id="element-295" data-mp="dquc1798gddz" />
        </PillButton>
        <button type="button" onClick={onRestart} className="mt-4 w-full font-body text-[12px] uppercase tracking-[0.18em] text-white/40 transition-colors hover:text-white/70 focus:outline-none focus-visible:text-white" data-id="element-296" data-mp="rhz4npe6o5et">
          Start over
        </button>
      </Reveal>
    </div>;
}